import { render, staticRenderFns } from "./DataSearch.vue?vue&type=template&id=674fef23&scoped=true&"
import script from "./DataSearch.vue?vue&type=script&lang=js&"
export * from "./DataSearch.vue?vue&type=script&lang=js&"
import style0 from "./DataSearch.vue?vue&type=style&index=0&id=674fef23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674fef23",
  null
  
)

export default component.exports